import dayjs from 'dayjs';

import styles from './DateChipSelect.scss';

type FormatDateTimeProps = {
  timestamp: string;
  withWeekday?: boolean;
}

export const formatDate = (timestamp: string): {label: React.ReactNode; subtext: React.ReactNode} | undefined => {
  const date = dayjs(timestamp);

  const day = date.format('D');
  const monthShort = date.format('MMM');
  const weekdayShort = date.format('ddd');

  if (!date.isValid()) {
    return undefined;
  }

  return {
    label: <span className={styles.date}>
      <span className={styles.day}>{weekdayShort}</span>
    </span>,
    subtext: <span className={styles.subtext}>{`${day} ${monthShort}`}</span>,
  };
};

export const formatDateTime = ({ timestamp, withWeekday = false }: FormatDateTimeProps): React.ReactNode => {
  const date = dayjs(timestamp);

  const day = date.format('D');
  const monthShort = date.format('MMM');
  const weekdayShort = date.format('ddd');

  if (!date.isValid()) {
    return undefined;
  }

  const formattedTime = date.format('h.mma').toLowerCase();

  return <span>
    {`${withWeekday ? `${weekdayShort} ` : ''}${day} ${monthShort} ${formattedTime}`}
  </span>;
};
